<div
  class="carousel-container"
  (mouseenter)="stopAutoplay()"
  (mouseleave)="startAutoplay()"
>
  <div class="carousel-track" [style.transform]="transformValue">
    <div class="carousel-card" *ngFor="let item of items">
      <div class="grey_gradientborder">
      <div class="card-content">
        <div class="card_content_inner">
          <div class="grey_gradientborder">
          <div class="card_image_wrapper">
            <img [src]="item.imageUrl" alt="" />
          </div>
          </div>
          <!-- <h3>{{ item.category_name }}</h3> -->
          <p>{{ item.category_name }}</p>
          <div class="card_border_img"></div>
          <h4 [innerHTML]="item.description"></h4>
        </div>
        <div class="mysteryschool_commonbutton_wrapper mystery_button_wing">
        <button class="mysteryschool_commonbutton" (click)="viewLesson(item)">
          View Lesson
        </button>
        </div>
      </div>
      </div>
    </div>
  </div>

  <div class="carousel-dots" *ngIf="canNavigate()">
    <button
      *ngFor="let _ of dotsArray; let i = index"
      class="dot"
      [class.active]="isActiveDot(i)"
      (click)="goTo(i)"
      [attr.aria-label]="'Go to slide ' + (i + 1)"
    ></button>
  </div>
</div>
<ng-container *ngIf="canNavigate()">
    <button
      class="carousel-nav prev"
      (click)="prev()"
      [disabled]="isPrevDisabled()"
      aria-label="Previous slide"
    >
      <img src="../../../assets/images/mystery-dashboard-images/trainingcenter_carousel_previousbutton.webp" alt="">
    </button>
    <button
      class="carousel-nav next"
      (click)="next()"
      [disabled]="isNextDisabled()"
      aria-label="Next slide"
    >
      <img src="../../../assets/images/mystery-dashboard-images/trainingcenter_carousel_nextbutton.webp" alt="">
    </button>
  </ng-container>